import type { FullFilledGeoLocation } from '@goparrot/common';
import { GeoProviderEnum } from '@goparrot/common';
import type { CreateUserAddressDto } from '@goparrot/customer-sdk';
import { AccuracyEnum } from '@goparrot/geocoder';
import type { IOrder } from '@goparrot/order-sdk';
import type { ReadStoreDto } from '@goparrot/store-v2-sdk';
import { deepObjectSanitizeHtml } from '@webstore-monorepo/shared/utils/url';

import axios from '../api/setup';

export const getAddressSuggestions = async (address: string, restParams?: any): Promise<FullFilledGeoLocation[]> => {
  const { merchantId } = window;
  const provider = GeoProviderEnum.GOOGLE_MAPS;
  const params = {
    ...restParams,
  };

  return axios.get(`${window.WEBSTORE_GATEWAY_URL}/api/v2/merchants/${merchantId}/geo-providers/${provider}/addresses/${encodeURIComponent(address)}/suggest`, {
    params,
  });
};

export const getAddressByCoords = async (coords: GeolocationCoordinates, restParams?: any): Promise<FullFilledGeoLocation[]> => {
  const { merchantId } = window;
  const provider = GeoProviderEnum.GOOGLE_MAPS;
  const params = {
    lon: coords.longitude,
    lat: coords.latitude,
    accuracy: AccuracyEnum.HOUSE_NUMBER,
    ...restParams,
  };

  return axios.get(`${window.WEBSTORE_GATEWAY_URL}/api/v2/merchants/${merchantId}/geo-providers/${provider}/reverse`, { params });
};

export const updateAddress = async (userAddress: CreateUserAddressDto): Promise<IOrder> => {
  const { merchantId, storeId } = window;

  return axios.patch(`${window.WEBSTORE_GATEWAY_URL}/api/v2/merchants/${merchantId}/stores/${storeId}/carts/address`, userAddress);
};

export const getStoreV2 = async (): Promise<ReadStoreDto> => {
  const { storeId } = window;

  return axios
    .get(`${window.WEBSTORE_GATEWAY_URL}/api/v3/stores/${storeId}`)
    .then((res) => deepObjectSanitizeHtml<ReadStoreDto>(res as unknown as ReadStoreDto));
};

export const getIframeUrl = async (): Promise<string> => {
  const { merchantId, storeId } = window;

  return axios.get(`${window.WEBSTORE_GATEWAY_URL}/api/v2/merchants/${merchantId}/stores/${storeId}/payments/iframe-url`);
};
